import { apiCall } from "./service";
import { apiGetRequest } from "helpers/Requests";
import {
  URL_AUDIT_LOG,
  URL_AUDIT_LOG_EXPORT,
  URL_AUDIT_LOG_ENTITY_TYPES,
  URL_AUDIT_LOG_NEW_COUNT,
} from "./URL";

const auditLogListRequest = (params) =>
  apiCall.get({ url: URL_AUDIT_LOG, params: params || {}, isAuthToken: true });

const entityActivityRequest = (entityType, entityId, params) =>
  apiCall.get({ url: `${URL_AUDIT_LOG}/${entityType}/${entityId}`, params: params || {}, isAuthToken: true });

const auditLogExportRequest = (params) =>
  apiCall.get({ url: URL_AUDIT_LOG_EXPORT, params: params || {}, isAuthToken: true });

const entityTypesRequest = () =>
  apiCall.get({ url: URL_AUDIT_LOG_ENTITY_TYPES, params: {}, isAuthToken: true });

// apiCall.get only forwards whitelisted query keys; since_id must be sent explicitly.
const auditLogNewCountRequest = (params) =>
  apiGetRequest(URL_AUDIT_LOG_NEW_COUNT, null, { params: params || {} }).then(
    (response) => response?.data ?? response
  );

export default {
  auditLogListRequest,
  entityActivityRequest,
  auditLogExportRequest,
  entityTypesRequest,
  auditLogNewCountRequest,
};
